'use strict';

import angular from 'angular';

export default class FinTxnViewCtrl {
  constructor($stateParams, $state, $window, LoaderSvc, DatetimeSvc, FinTxnSvc,
    GroupAuthSvc) {
    this.ctxId = $stateParams.ctxId;
    this.groupId = $stateParams.groupId; // current group
    this.ftId = $stateParams.ftId;
    var that = this;

    if(!this.ftId) {
      return $state.go('group.view.groupTransaction.list');
    }

    // authorization
    GroupAuthSvc.validatePermission(this.groupId, 'financialTransaction', 'R');

    var reqParams = {
      groupId: that.groupId,
      id: that.ftId,
      includeStripeLatestStatus: true,
      includeStripeLiveRefresh: true
    };

    //load groupTransaction
    function loadFinTxn() {
      LoaderSvc.start();
      FinTxnSvc.get(reqParams).$promise
        .then(function(finTxn) {
          that.financialTransaction = finTxn;
          if(finTxn.rejectedAt) {
          // delete financialTransaction.archive.rejectedAt;
            finTxn = angular.merge(finTxn, finTxn.archive);
          }
          // expose the toGroups that this user can administer/change dates
          if(GroupAuthSvc.hasPermission(finTxn.toGroup.id,
            'financialTransaction', 'U')) {
            that.hasPermissionToAccept = true;
          }

          LoaderSvc.stop();
        }).catch(function() {
          LoaderSvc.stopError('FT1: Error loading Financial Transaction');
        });
    }
    loadFinTxn();

    ////////////////////////////////////////////////////////////////////////////
    /// Select price date (super admin only)
    ////////////////////////////////////////////////////////////////////////////
    // datepicker
    that.today = new Date();
    that.formvm = {formPostDate: new Date()};
    that.dateFormat = 'M/d/yy';
    that.openActive = function($event, dateType) {
      $event.preventDefault();
      $event.stopPropagation();
      that.formvm[dateType + 'Open'] = true;
    };

    that.enablePostDate = function() {
      that.editPostDate = true;
    };

    that.updatePostDate = function() {
      that.editPostDate = false;
      LoaderSvc.start();
      var postDate = DatetimeSvc.getDatePropString(that.formvm.formPostDate);
      var postDateReq = angular.merge({postDate}, reqParams);
      FinTxnSvc.setPostDate(postDateReq).$promise
        .then(function() {
          LoaderSvc.stop();
          loadFinTxn();
        }).catch(function() {
          LoaderSvc.stopError('FT2: Error loading Financial Transaction');
        });
    };

    ////////////////////////////////////////////////////////////////////////////
    /// Accept/Reject Transaction
    ////////////////////////////////////////////////////////////////////////////
    that.acceptFinTxn = function() {
      LoaderSvc.start();
      FinTxnSvc.accept(reqParams).$promise
        .then(function() {
          LoaderSvc.stop();
          loadFinTxn();
        }).catch(function() {
          LoaderSvc.stopError('FT3: Error loading Financial Transaction');
        });
    };

    that.canRejectStripePayment = function() {
      var rejectableStripeStatuses = [
        'requires_payment_method',
        'requires_confirmation',
        'requires_action'
      ];

      return !!that.financialTransaction
        && (that.financialTransaction.type === 'card'
            || that.financialTransaction.type === 'account')
        && that.hasPermissionToAccept
        && !that.financialTransaction.rejectedAt
        && !!that.financialTransaction.stripeLatestStatus
        && rejectableStripeStatuses.includes(
          that.financialTransaction.stripeLatestStatus
        );
    };

    that.rejectFinTxn = function() {
      var confirmMsg = `Are you sure you want to permanently reject this payment?
      (This cannot be undone and will have to be resubmitted in the future)`;

      if(that.canRejectStripePayment()) {
        confirmMsg += '\n\nWARNING: Before rejecting, verify in Stripe '
          + 'that there is no successful or pending transaction '
          + 'for this payment.';
      }

      if($window.confirm(confirmMsg)) {
        LoaderSvc.start();
        FinTxnSvc.reject(reqParams).$promise
          .then(function() {
            LoaderSvc.stop();
            loadFinTxn();
          }).catch(function() {
            LoaderSvc.stopError('FT4: Error loading Financial Transaction');
          });
      }
    };
  }
}

FinTxnViewCtrl.$inject = [
  '$stateParams',
  '$state',
  '$window',
  'LoaderSvc',
  'DatetimeSvc',
  'FinTxnSvc',
  'GroupAuthSvc'
];
